import React from 'react';
import EventRefundContainer from '../../../Containers/AdminContainer/EventRefund';
const EventRefundScreen = () => {
  return <EventRefundContainer />;
};

export default EventRefundScreen;
